import React from "react";
import {Autocomplete, Box, Button, Container, IconButton, ListItem, ListItemText, Modal, TextField, Typography} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {addStaff, changeStaff, getRiyoDaySearch} from "../../api/client";

export default function AssignStff(props) {
  const loadParams = (nm) => {
    return sessionStorage.getItem(nm) || "";
  };
  // const saveParams = (nm, val) => {
  //   return sessionStorage.setItem(nm, val);
  // };
  // const loadJson = (nm) => {
  //   return JSON.parse(sessionStorage.getItem(nm)) || [];
  // };
  const saveJson = (nm, val) => {
    return sessionStorage.setItem(nm, JSON.stringify(val));
  };
  const [state, setState] = React.useState({
    stffNo: "",
    confirmExpanded: false,
    addFg: true
  });
  const close = () => {
    props.setState({...props.state, assignExpanded: false});
    props.setEdit({...props.edit, s2st004200Slug: "", s2st004211Slug: "", noValue: "", stffNo: "", item: {}, stffList: []});
  };
  const clickAssignBtn = (addFg) => {
    if (Boolean(state.stffNo)) {
      setState({...state, confirmExpanded: true, addFg: addFg});
      props.setEdit({...props.edit, stffNo: state.stffNo});
    } else {
      props.errorFunc({response: {data: {errors: "職員を選択してください。"}}});
    };
  };
  async function addChangeStaff() {
    const result = await (Boolean(state.addFg) ? addStaff(props.edit) : changeStaff(props.edit)).catch(error => props.errorFunc(error));
    if (Boolean(result)) {
      const data = await getRiyoDaySearch({ymdDt: loadParams("editScheduleDate"), bsJg: loadParams("jgCd"), riyoNo: loadParams("riyoNo")}).catch(error => props.errorFunc(error));
      // props.propSetState({...props.propState, data: data.data});
      saveJson("data", data.data);
      props.setToastState({...props.toastState, error: false, message: result.data.message});
      close();
    };
    setState({...state, confirmExpanded: false})
  };

  return (
    <React.Fragment>
      <Container
        maxWidth = "sm"
        sx = {{p: 2, pt: 0, flexGrow: 1}}
      >
        <Box
          sx = {{display: "flex", mt: 1, mb: 1}}
        >
          <IconButton
            aria-label = "menu"
            color = "default"
            onClick = {() => close()}
            size = "small"
            sx = {{ml: "auto"}}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <ListItem
          className = "bgcolor-gray-quarter"
          alignItems = "flex-start"
          sx = {{mt: 1, mb: 1, pt: 2, pb: 2, pl: 4, pr: 4}}
        >
          <ListItemText
            primary = {
              <React.Fragment>
                <Typography
                  sx = {{display: "inline"}}
                >
                  職員：{props.edit.item.stffNm || "未割当"}
                </Typography>
              </React.Fragment>
            }
            secondary = {
              <React.Fragment>
                {!Boolean(props.edit.item.timelessOtherFg) &&
                <Typography
                  sx = {{display: "inline"}}
                >
                  予定：{props.edit.item.hourfDt}～{props.edit.item.hourtDt}
                </Typography>}
                {!Boolean(props.edit.item.timelessOtherFg) && <br></br>}
                <Typography
                  sx = {{display: "inline"}}
                >
                  {props.edit.item.serviceNm || "--"}
                </Typography>
              </React.Fragment>
            }
            secondaryTypographyProps = {{component: "div", sx: {mt: 1}}}
          />
        </ListItem>
        <Box
          sx = {{mt: 2, mb: 2}}
        >
          <Autocomplete
            clearIcon = {false}
            componentsProps = {{
              popper: {
                placement: "top",
                modifiers: [{name: "flip", enabled: false}]
              }
            }}
            fullWidth
            getOptionLabel = {(option) => option[1]}
            groupBy = {(option) => option[3]}
            noOptionsText = "データはありません。"
            onChange = {(e, val) => setState({...state, stffNo: val[0]})}
            options = {props.edit.stffList}
            renderInput = {(params) => <TextField {...params} label = "職員" size = "small" />}
          />
          <Typography
            sx = {{mt: 0.5, ml: 1.75, color: "text.secondary", fontSize: "0.75rem", textAlign: "left"}}
          >
            ☆：重複
            <br />
            ★：時間外/割当不可
          </Typography>
          {/* <FormControl
            size = "small"
            sx = {{width: "100%"}}
          >
            <InputLabel
              sx = {{zIndex: -1}}
            >
              職員
            </InputLabel>
            <Select
              fullWidth
              label = "職員"
              MenuProps = {{PaperProps: {style: {maxHeight: 200}}}}
              onChange = {(e) => setState({...state, stffNo: e.target.value})}
              value = {state.stffNo}
            >
              {props.edit.stffList.map((stff) => (
                <MenuItem
                  key = {"stff" + stff[0]}
                  value = {stff[0]}
                >
                  {stff[1]}
                </MenuItem>
              ))}
            </Select>
          </FormControl> */}
        </Box>
        <Box
          sx = {{display: "flex", mt: 2, mb: 2}}
        >
          <Button
            className = "btn-submit"
            onClick = {() => clickAssignBtn(true)}
            sx = {{display: "block", mr: "auto", pt: 0.5, pb: 0.5, width: 120}}
          >
            <Typography
              className = "btn-txt-sm"
            >
              職員追加
            </Typography>
          </Button>
          {Boolean(props.edit.item.stffNo) &&
          <Button
            className = "btn-submit"
            onClick = {() => clickAssignBtn(false)}
            sx = {{display: "block", ml: "auto", pt: 0.5, pb: 0.5, width: 120}}
          >
            <Typography
              className = "btn-txt-sm"
            >
              職員変更
            </Typography>
          </Button>}
        </Box>
      </Container>
      <Modal
        open = {state.confirmExpanded}
        closeAfterTransition
      >
        <Box
          className = "basic-modal"
        >
          <Typography>
            職員を{state.addFg ? "追加" : "変更"}しますか？
          </Typography>
          <Box
            sx = {{textAlign: "right"}}
          >
            <Button
              onClick = {() => addChangeStaff()}
              sx = {{}}
              >
              はい
            </Button>
            <Button
              onClick = {() => {
                setState({...state, confirmExpanded: false});
              }}
              sx = {{}}
            >
              いいえ
            </Button>
          </Box>
        </Box>
      </Modal>
    </React.Fragment>
  );
};
